import React from 'react';
import { useEffect } from 'react';

const ListGraphicEconomicsFilters = (params) => {

    useEffect(() => {        
        console.log("Filtros de gráfica de histórico economics cargados correctamente")      
    });

    const listGraphicFilters = params.objEtiquetas.map((filtro, index) =>    
        <React.Fragment key={"Etiqueta"+index}>
            {   index !== 0 ?
                <button className='button tertiary size-s' id={"Etiqueta"+index} style={{ color: params.backupColoresGrafica[index-1].color}} onClick={() => params.showHideSeries(params.chartObj,params.googleObj,[{"row":null,"column":index}])}>{filtro}</button>            
                :
                <></>
            }
        </React.Fragment>
    );   

    return (        
        <div className='horizontal gap-03 wrap center chart-legend' >            
            {listGraphicFilters}
        </div>
    );
}

export default ListGraphicEconomicsFilters